module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hrms-orgchart"
  }, [_c('div', {
    attrs: {
      "id": "chart-container"
    }
  }, [_c('div', {
    staticClass: "orgchart"
  }, [_c('orgchart-node', {
    attrs: {
      "data": _vm.data,
      "rootNode": true,
      "labels": _vm.labels,
      "receivedOrgBodyDetail": _vm.receivedOrgBodyDetail
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f43d61f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orgchart/component.vue
// module id = 3618
// module chunks = 1